import src from "IMAGE";
export default { src, width: 29, height: 21, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
